export const segmentLogic = {
  ActivateChickFilAUser: (email: string) => /@(chick-fil-a|cfafranchisee)\.com$/.test(email),
};